var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.getLink(),"target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/tripadvisor_button_transparent.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }